import React, { FC } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import StatusToastNotification from '@components/StatusToastNotification';
import { useProfileContext } from '@components/Contexts/ProfileContext';
import { PROFILE_PAGE_TYPES } from '@common/types';

type Props = {
  status: 'success' | 'error' | null;
  clearStatus: () => void;
  isMobileView: boolean;
};
const ContactStatusToast: FC<Props> = ({
  status,
  clearStatus,
  isMobileView,
}) => {
  const { t } = useTranslation();
  const { profilePageType } = useProfileContext();

  if (!status) return null;

  const commonProps = {
    duration: 8000,
    dismissible: true,
    onDismiss: () => clearStatus(),
  };

  const marketplaceConfig = {
    success: {
      dataHook: 'brief-success-message',
      message: t('brief-submit-success-message'),
    },
    error: {
      dataHook: 'brief-error-message',
      message: t('brief-submit-error-message'),
    },
  } as const;

  const agencyConfig = {
    success: {
      dataHook: 'agency-contact-success-message',
      message: t('marketplace.profile-page.agency-contact-form.submit-success'),
    },
    error: {
      dataHook: 'agency-contact-error-message',
      message: t('marketplace.profile-page.agency-contact-form.submit-error'),
    },
  };

  const config =
    profilePageType === PROFILE_PAGE_TYPES.agency
      ? agencyConfig
      : marketplaceConfig;

  const toastProps = config[status];

  return (
    <StatusToastNotification
      key={`brief-${status}-message`}
      status={status}
      isMobileView={isMobileView}
      {...commonProps}
      {...toastProps}
    />
  );
};

export default ContactStatusToast;
